(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["job-listing"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('hq-job-listings')) return;
  const DAY = 86400000;
  // An explicit offset avoids deadlines changing with the visitor's timezone.
  function parseDeadline(value) {
    if (!value) return null;
    const parts = value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/);
    if (!parts) return NaN;
    const [,year,month,day,hour,minute,second] = parts;
    const daysInMonth = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
    if (+month < 1 || +month > 12 || +day < 1 || +day > daysInMonth || +hour > 23 || +minute > 59 || +(second || 0) > 59) return NaN;
    return Date.parse(value);
  }
  const scrollLock = {
    owners: new Set(), previous: '',
    add(owner) {
      if (!this.owners.size) { this.previous = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; }
      this.owners.add(owner);
    },
    remove(owner) {
      if (!this.owners.delete(owner)) return;
      if (!this.owners.size) document.documentElement.style.overflow = this.previous;
    }
  };
  class HQJobListings extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    init() {
      if (!this.isConnected || this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const mobileLayout = window.matchMedia('(max-width: 700px)');
      this.jobs = Array.from(this.querySelectorAll('[data-job-id]')).map(card => {
        const job = { card, deadline: parseDeadline(card.dataset.closing), closed: false };
        const details = card.querySelector('.hq-details');
        const summary = details.querySelector('summary');
        const full = details.querySelector('.hq-full');
        const footer = full.querySelector('.hq-application');
        Object.assign(job, { details, summary, full, footer });
        // Keep an inline details fallback when modal dialogs are unavailable.
        if (typeof HTMLDialogElement !== 'undefined' && typeof HTMLDialogElement.prototype.showModal === 'function') {
          const dialog = document.createElement('dialog');
          dialog.className = 'hq-dialog';
          dialog.id = `${this.id}-${card.dataset.jobId}-dialog`;
          const header = document.createElement('div');
          header.className = 'hq-dialog-header';
          const eyebrow = document.createElement('span');
          eyebrow.className = 'hq-eyebrow';
          eyebrow.textContent = 'Job details';
          const title = document.createElement('h3');
          title.id = `${dialog.id}-title`;
          title.textContent = card.querySelector('.hq-title-wrap h3').textContent;
          dialog.setAttribute('aria-labelledby', title.id);
          const close = document.createElement('button');
          close.type = 'button'; close.className = 'hq-close';
          close.setAttribute('aria-label', 'Close job details');
          close.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18"/></svg>';
          const heading = document.createElement('div'); heading.className = 'hq-dialog-heading';
          heading.append(eyebrow, title); header.append(heading, close);
          const meta = card.querySelector('[data-job-meta]').cloneNode(true);
          meta.removeAttribute('data-job-meta');
          const body = document.createElement('div'); body.className = 'hq-dialog-body';
          // On mobile, the title and pills scroll with the description; only the close button stays above it.
          const positionMeta = () => {
            if (mobileLayout.matches) body.prepend(heading, ...(meta.children.length ? [meta] : []));
            else {
              header.prepend(heading);
              if (meta.children.length) header.append(meta);
            }
          };
          positionMeta();
          mobileLayout.addEventListener('change', positionMeta, options);
          body.append(full); dialog.append(header, body, footer); card.append(dialog);
          card.querySelector('.hq-card-bottom').append(details);
          summary.setAttribute('aria-haspopup', 'dialog'); summary.setAttribute('aria-controls', dialog.id);
          Object.assign(job, { dialog, body, close });
          summary.addEventListener('click', event => { event.preventDefault(); this.open(job); }, options);
          close.addEventListener('click', () => dialog.close(), options);
          // Close only when both pointer-down and click happened outside the panel.
          let outsideDown = false;
          const outside = event => { const r = dialog.getBoundingClientRect(); return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom; };
          dialog.addEventListener('pointerdown', event => { outsideDown = event.target === dialog && outside(event); }, options);
          dialog.addEventListener('click', event => { if (outsideDown && event.target === dialog && outside(event)) dialog.close(); outsideDown = false; }, options);
          dialog.addEventListener('close', () => { scrollLock.remove(dialog); if (summary.isConnected && !card.hidden) summary.focus({ preventScroll: true }); }, options);
        }
        card.querySelector('.hq-apply').addEventListener('click', event => {
          this.update();
          if (job.closed || !Number.isFinite(job.deadline) && job.deadline !== null || event.currentTarget.getAttribute('aria-disabled') === 'true') event.preventDefault();
        }, options);
        return job;
      });
      if (this.jobs.some(job => job.dialog)) this.classList.add('hq-enhanced');
      this.update();
      this.timer = setInterval(() => this.update(), 1000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.update(); }, options);
      window.addEventListener('pageshow', () => this.update(), options);
      document.addEventListener('shopify:block:select', event => {
        const job = this.jobs.find(item => item.card.dataset.jobId === event.detail?.blockId);
        if (job) this.open(job);
      }, options);
      document.addEventListener('shopify:block:deselect', () => this.jobs.forEach(job => { if (job.dialog?.open) job.dialog.close(); }), options);
    }
    open(job) {
      this.update();
      if (job.card.hidden) return;
      if (!job.dialog) { job.details.open = true; return; }
      if (job.dialog.open) return;
      this.jobs.forEach(item => { if (item.dialog?.open) item.dialog.close(); });
      job.dialog.showModal(); scrollLock.add(job.dialog); job.body.scrollTop = 0; job.close.focus();
    }
    update() {
      const now = Date.now(); let openCount = 0; let visibleCount = 0;
      this.jobs.forEach(job => {
        const manual = job.card.dataset.manuallyClosed === 'true';
        const invalid = job.deadline !== null && !Number.isFinite(job.deadline);
        const left = job.deadline === null ? Infinity : job.deadline - now;
        job.closed = manual || left <= 0;
        let label = 'Open until filled';
        if (job.closed) label = 'Applications closed';
        else if (invalid) label = 'Closing date to be confirmed';
        else if (left !== Infinity) {
          if (left >= DAY) { const days = Math.ceil(left / DAY); label = `${days} ${days === 1 ? 'day' : 'days'} left`; }
          else if (left >= 3600000) { const hours = Math.ceil(left / 3600000); label = `${hours} ${hours === 1 ? 'hour' : 'hours'} left`; }
          else if (left >= 60000) { const minutes = Math.ceil(left / 60000); label = `${minutes} ${minutes === 1 ? 'minute' : 'minutes'} left`; }
          else label = 'Less than 1 minute left';
        }
        job.card.querySelectorAll('[data-countdown]').forEach(element => {
          if (element.textContent !== label) element.textContent = label;
          element.parentElement.classList.toggle('hq-urgent', !job.closed && !invalid && left <= 3 * DAY);
          element.parentElement.classList.toggle('hq-closed', job.closed);
          element.parentElement.classList.toggle('hq-open-ended', label === 'Open until filled');
        });
        const closingLabel = job.card.querySelector('[data-closing-label]');
        if (closingLabel && !job.formatted) {
          if (invalid) {
            closingLabel.textContent = this.dataset.editor === 'true' ? 'Check deadline: use YYYY-MM-DDTHH:MM:SS+00:00 or +01:00.' : 'Please contact us for the closing date.';
          } else {
            const time = closingLabel.querySelector('time');
            time.textContent = new Intl.DateTimeFormat('en-GB', {timeZone:'Europe/London', day:'numeric', month:'short', year:'numeric', hour:'2-digit', minute:'2-digit', timeZoneName:'short'}).format(job.deadline);
            closingLabel.replaceChildren(document.createTextNode('Closes '), time, document.createTextNode(' (UK time)'));
          }
          job.formatted = true;
        }
        const apply = job.card.querySelector('.hq-apply');
        const url = apply.dataset.applyUrl;
        const disabled = job.closed || invalid || !url;
        const buttonLabel = job.closed ? 'Applications closed' : invalid || !url ? 'Applications opening soon' : 'Apply now \u2192';
        if (apply.textContent !== buttonLabel) apply.textContent = buttonLabel;
        if (disabled) { apply.removeAttribute('href'); apply.setAttribute('aria-disabled','true'); apply.setAttribute('tabindex','-1'); apply.setAttribute('role','link'); }
        else { apply.setAttribute('href', url); apply.removeAttribute('aria-disabled'); apply.removeAttribute('tabindex'); apply.removeAttribute('role'); }
        if (!job.closed && !invalid) openCount++;
        const hide = job.closed && this.dataset.hideClosed === 'true' && this.dataset.editor !== 'true';
        if (hide && job.dialog?.open) job.dialog.close();
        job.card.hidden = hide;
        if (!hide) visibleCount++;
      });
      const count = this.querySelector('[data-role-count]');
      const text = `${openCount} ${openCount === 1 ? 'open role' : 'open roles'}`;
      if (count.textContent !== text) count.textContent = text;
      count.parentElement.hidden = false;
      this.querySelector('[data-empty]').hidden = visibleCount > 0;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); clearInterval(this.timer);
      if (!this.controller) return;
      this.controller.abort(); this.controller = null;
      this.jobs.forEach(job => {
        if (!job.dialog) return;
        if (job.dialog.open) job.dialog.close();
        scrollLock.remove(job.dialog);
        job.full.append(job.footer); job.details.append(job.full); job.card.append(job.details);
        job.summary.removeAttribute('aria-haspopup'); job.summary.removeAttribute('aria-controls'); job.dialog.remove();
      });
      this.classList.remove('hq-enhanced');
    }
  }
  customElements.define('hq-job-listings', HQJobListings);
})();

  } catch(e) { console.error(e); }
})();
})();
